import React, { useState } from 'react';
import { Box, Button, Text, Layer, Heading, Anchor } from 'grommet';
import { Close } from 'grommet-icons';

const HitScopeHeader: React.FC<{ showHelp?: boolean }> = ({
  showHelp = false,
}) => {
  const [showLearnMoreModal, setShowLearnMoreModal] = useState<boolean>(false);
  return (
    <Box justify="between" direction="row">
      <img
        src="/HitScopeLogo.svg"
        alt="hitscope logo"
        style={{ width: '50%', marginTop: '2vh' }}
      />
      {showHelp && (
        <>
          <Button
            plain
            label={
              <Text color="secondary-1" size="small">
                How does this work?
              </Text>
            }
            onClick={() => {
              setShowLearnMoreModal(true);
            }}
          />
          {showLearnMoreModal && (
            <LearnMoreModal setShowLearnMoreModal={setShowLearnMoreModal} />
          )}
        </>
      )}
    </Box>
  );
};

const HitScopeFeedback = () => (
  <Box margin={{ top: '.5rem', bottom: '.5rem' }}>
    <Text>
      Have feedback?{' '}
      <Anchor
        href="https://docs.google.com/forms/d/e/1FAIpQLSeNT87DcBq1fMOrfDKLl_sBEmJxN8gRZI-rTIqpOSI3BW7jKw/viewform?usp=sf_link"
        target="_blank"
      >
        Let us know!
      </Anchor>
    </Text>
  </Box>
);

const LearnMoreModal = ({
  setShowLearnMoreModal,
}: {
  setShowLearnMoreModal: (show: boolean) => void;
}) => {
  return (
    <Layer
      onEsc={() => {
        setShowLearnMoreModal(false);
      }}
      modal
    >
      <Box width="large" pad="medium" gap="medium">
        <Box
          align="baseline"
          direction="row"
          justify="between"
          fill="horizontal"
        >
          <Heading level={3}>HitScope BETA</Heading>
          <Button
            icon={<Close />}
            onClick={() => {
              setShowLearnMoreModal(false);
            }}
          />
        </Box>
        <Text>
          HitScope is a quick way to view all of a player’s batted ball events.
          In just 2 minutes, you can catch up on every hit from last week’s
          tournament.
        </Text>
        <Text margin={{ bottom: 'medium' }}>
          HitScope videos are updated as your player’s clip catalog grows!
          Viewers can filter the video by recent games or by productive at-bats.
        </Text>

        <Text margin={{ bottom: 'none' }}>Why are some clips missing?</Text>
        <ul style={{ marginTop: 0 }}>
          <li>
            <Text>Your player must be claimed.</Text>
          </li>
          <li>
            <Text>Your team must be using sidelineHD team PRO.</Text>
          </li>
          <li>
            <Text>
              The at-bat clip must be assigned to your player. Assigned clips
              show on your player’s page.
            </Text>
          </li>
          <li>
            <Text>
              Our system detects ball contact events. To do this, the clip needs
              to have good quality video and audio.
            </Text>
          </li>
        </ul>
      </Box>
    </Layer>
  );
};

export { HitScopeHeader, HitScopeFeedback };
